import { z } from "zod";

export const ServiceProductSlotItemSchema = z.object({
  id: z.string().uuid(),
  startTime: z.string().datetime(),
  endTime: z.string().datetime(),
  isAvailable: z.boolean(),
  serviceProductId: z.string().uuid(),
  serviceProductName: z.string().optional(),
  duration: z.number().optional(),
  date: z.string().date(),
  timeSlot: z.string(),
});

export type ServiceProductSlotItemType = z.infer<
  typeof ServiceProductSlotItemSchema
>;

export const ServiceProductSlotsListSchema = z.array(
  ServiceProductSlotItemSchema,
);

export type ServiceProductSlotsListType = z.infer<
  typeof ServiceProductSlotsListSchema
>;
